function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M4.2 5.5h22v28.2h-22z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "b"
}, React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.2 5.5H12.9v4.4h9.3c.7 0 1.3.5 1.3 1.2v.2c0 .5-.4 1-.9 1.1h-9.8c-.2.8-.9 1.4-1.7 1.4h-7v17.9c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7.5c.1-1.1-.8-2-1.9-2m-.6 22.7c0 .7-.6 1.2-1.3 1.2H8.2c-.7 0-1.3-.5-1.3-1.2V28c0-.7.6-1.2 1.3-1.2h14.1c.7 0 1.3.5 1.3 1.2v.2zm0-5.6c0 .7-.6 1.2-1.3 1.2H8.2c-.7 0-1.3-.5-1.3-1.2v-.2c0-.7.6-1.2 1.3-1.2h14.1c.7 0 1.3.5 1.3 1.2v.2zm0-5.7c0 .7-.6 1.2-1.3 1.2H8.2c-.7 0-1.3-.5-1.3-1.2v-.2c0-.7.6-1.2 1.3-1.2h14.1c.7 0 1.3.5 1.3 1.2v.2z",
  clipPath: "url(#b)",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("defs", null, React.createElement("path", {
  id: "c",
  d: "M4.2 5.5h22v28.2h-22z"
})), React.createElement("clipPath", {
  id: "d"
}, React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
})), React.createElement("path", {
  d: "M11.5 12.1V5.5l-6.9 6.9h6.6c.1 0 .3-.1.3-.3",
  clipPath: "url(#d)",
  fill: "#fff"
}));

var SvgIconClaims = function SvgIconClaims(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30.4 39.2"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

export default SvgIconClaims;